module.exports = {
  defaultLocale: 'en',
  locales: ['en', 'zh'],
  prerender: true,
  gtag: '',
  stage: {
    mobile: 320,
    tablet: 768,
    desktop: 1440,
  },
  mediaQuery: {
    tablet: 576,
    desktop: 992,
  },
};
